import { render, staticRenderFns } from "./paypal_pay.vue?vue&type=template&id=7551d491&"
import script from "./paypal_pay.vue?vue&type=script&lang=js&"
export * from "./paypal_pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports